<script setup>
import BaseModal from "@/components/global-themed/BaseModal.vue";
import KitIcon from "@/components/approval-center/partials/kit/KitIcon.vue";
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";
import ModalHeading from "@/components/global-themed/ui/modals/ModalHeading.vue";
import ModalSubText from "@/components/global-themed/ui/modals/ModalSubText.vue";
import ModalHeader from "@/components/global-themed/ui/modals/ModalHeader.vue";
import KitModalHeader from "@/components/global-themed/ui/modals/KitModalHeader.vue";
import ModalContentWrapper from "@/components/global-themed/ui/modals/ModalContentWrapper.vue";

defineProps({
  confirmLabel: {
    type: String,
    default: "Confirm",
  },
  cancelLabel: {
    type: String,
    default: "Cancel",
  },
  state: {
    type: String,
    default: "success",
  },
});

const emit = defineEmits(['close', 'confirm']);
</script>

<template>
  <Teleport to=".tailwind">
    <BaseModal
      modal-class="tw-w-[720px]"
      @close="emit('close')"
    >
      <ModalContentWrapper>
        <KitModalHeader>
          <KitIcon
            class="tw-w-[88px]"
            :state="state"
          />

          <ModalHeader>
            <ModalHeading>
              <slot name="heading" />
            </ModalHeading>

            <ModalSubText>
              <slot name="text" />
            </ModalSubText>

            <ModalSubText>
              <slot name="subtext" />
            </ModalSubText>
          </ModalHeader>
        </KitModalHeader>

        <div class="tw-flex tw-items-center tw-gap-4 tw-self-end">
          <DefaultButton
            variant="primary-inverted"
            @click="emit('close')"
          >
            {{ cancelLabel }}
          </DefaultButton>
          <DefaultButton @click="emit('confirm')">
            {{ confirmLabel }}
          </DefaultButton>
        </div>
      </ModalContentWrapper>
    </BaseModal>
  </Teleport>
</template>

